import { generateTypes } from '../../utils/HttpReducerHelper';

const businessFundingSearches = generateTypes('MONITOR_CONNECT_WIZZARD', 'CLIENT_FUNDING_SEARCHES');
const clientsAccounts = generateTypes('MONITOR_CONNECT_WIZZARD', 'CLIENT_ACCOUNTS');
const activeLenders = generateTypes('MONITOR_CONNECT_WIZZARD', 'ACTIVE_LENDERS');
const creditLinesFacilityMap = generateTypes('MONITOR_CONNECT_WIZZARD', 'CREDIT_LINES');
const facilitiesMap = generateTypes('MONITOR_CONNECT_WIZZARD', 'FACILITIES');
const deleteFacility = generateTypes('MONITOR_CONNECT_WIZZARD', 'DELETE_FACILITY');
const saveFacilityType = generateTypes('MONITOR_CONNECT_WIZZARD', 'SAVE_FACILITY');

const OPEN_WIZZARD = 'platfi-ui-app/MONITOR_CONNECT_WIZZARD/OPEN';
const CLOSE_WIZZARD = 'platfi-ui-app/MONITOR_CONNECT_WIZZARD/CLOSE';

const SET_WIZZARD_CLIENT = 'platfi-ui-app/MONITOR_CONNECT_WIZZARD/SET_MONITOR_WIZZARD_CLIENT';
const SET_WIZZARD_ACCOUNTING_SOLUTION =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/SET_MONITOR_WIZZARD_SOLUTION';

const OPEN_WIZZARD_DATA_LOADING_MODAL =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/OPEN_MONITOR_WIZZARD_DATA_LOADING_MODAL';
const CLOSE_WIZZARD_DATA_LOADING_MODAL =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/CLOSE_MONITOR_WIZZARD_DATA_LOADING_MODAL';

const OPEN_WIZZARD_DATA_LOADING_ERROR_MODAL =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/OPEN_MONITOR_WIZZARD_DATA_LOADING_ERROR_MODAL';
const CLOSE_WIZZARD_DATA_LOADING_ERROR_MODAL =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/CLOSE_MONITOR_WIZZARD_DATA_LOADING_ERROR_MODAL';

const ADD_WIZZARD_CREDIT_FACILITY =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/ADD_WIZZARD_CREDIT_FACILITY';
const REMOVE_WIZZARD_CREDIT_FACILITY =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/REMOVE_WIZZARD_CREDIT_FACILITY';

const ADD_WIZZARD_LEDGER_PROVIDER_FACILITY =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/ADD_WIZZARD_LEDGER_PROVIDER_FACILITY';
const REMOVE_WIZZARD_LEDGER_PROVIDER_FACILITY =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/REMOVE_WIZZARD_LEDGER_PROVIDER_FACILITY';

const SET_WIZZARD_PROVIDER_MAP_VALIDITY =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/SET_WIZZARD_PROVIDER_MAP_VALIDITY';

const TRIGGER_XERO_UPLOAD = 'platfi-ui-app/MONITOR_CONNECT_WIZZARD/TRIGGER_XERO_UPLOAD';
const SAVE_INTEGRATION_PAYLOAD = 'platfi-ui-app/MONITOR_CONNECT_WIZZARD/SAVE_INTEGRATION_PAYLOAD';
const RESET_INTEGRATION_PAYLOAD = 'platfi-ui-app/MONITOR_CONNECT_WIZZARD/RESET_INTEGRATION_PAYLOAD';

const CONNECTION_HISTORY_LIST_ITEMS =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/CONNECTION_HISTORY_LIST_ITEMS';
const ADD_CONNECTION_HISTORY_LIST_ITEM =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/ADD_CONNECTION_HISTORY_LIST_ITEM';
const REMOVE_CONNECTION_HISTORY_LIST_ITEM =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/REMOVE_CONNECTION_HISTORY_LIST_ITEM';
const UPDATE_CONNECTION_HISTORY_LIST_ITEM =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/UPDATE_CONNECTION_HISTORY_LIST_ITEM';

const SSE_UPDATE_SNAPSHOT_GENERATION_PROGRESS = '@@SSE/entity/ledger/snapshot/generation';
const SSE_UPDATE_FACILITY_GENERATION_PROGRESS = '@@SSE/entity/facility/generation';

const SET_EDIT_FACILITY_WIZZARD =
  'platfi-ui-app/SET_EDIT_FACILITY_WIZZARD/SAVE_ACTIVE_EDIT_FACILITY_ID';

export {
  activeLenders,
  clientsAccounts,
  businessFundingSearches,
  creditLinesFacilityMap,
  facilitiesMap,
  deleteFacility,
  saveFacilityType,
  ADD_WIZZARD_CREDIT_FACILITY,
  ADD_WIZZARD_LEDGER_PROVIDER_FACILITY,
  CLOSE_WIZZARD,
  CLOSE_WIZZARD_DATA_LOADING_ERROR_MODAL,
  CLOSE_WIZZARD_DATA_LOADING_MODAL,
  OPEN_WIZZARD,
  OPEN_WIZZARD_DATA_LOADING_ERROR_MODAL,
  OPEN_WIZZARD_DATA_LOADING_MODAL,
  REMOVE_WIZZARD_CREDIT_FACILITY,
  REMOVE_WIZZARD_LEDGER_PROVIDER_FACILITY,
  SET_WIZZARD_ACCOUNTING_SOLUTION,
  SET_WIZZARD_CLIENT,
  SET_WIZZARD_PROVIDER_MAP_VALIDITY,
  TRIGGER_XERO_UPLOAD,
  SAVE_INTEGRATION_PAYLOAD,
  RESET_INTEGRATION_PAYLOAD,
  CONNECTION_HISTORY_LIST_ITEMS,
  ADD_CONNECTION_HISTORY_LIST_ITEM,
  REMOVE_CONNECTION_HISTORY_LIST_ITEM,
  UPDATE_CONNECTION_HISTORY_LIST_ITEM,
  SSE_UPDATE_SNAPSHOT_GENERATION_PROGRESS,
  SSE_UPDATE_FACILITY_GENERATION_PROGRESS,
  SET_EDIT_FACILITY_WIZZARD,
};
